import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';        // ✅ normal CSS
// import 'aos/dist/aos.css';   // ✅ AOS CSS



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
